export const DOMO_SHEETS = {
  collageImageAssets: 'https://teachtci.domo.com/kpis/details/417525030?internal=true',
  duplicateImageNamesAndLicenceInfo: 'https://teachtci.domo.com/kpis/details/905711181?internal=true',
};
